import { IBaseAnalyticsCombined } from "../analyticsDataStore";
// this file has been moved to "LQMAT Team Site - Documents\3. Functional\Cube Client Portal 2.0\Analytics"
export const mockDataReduced: IBaseAnalyticsCombined[] = [];
